"use client";

import type { PropsWithChildren, ReactNode } from "react";

import { cn } from "../../utils";
import { Button } from "../button";
import { MenuBurgerIcon } from "../icons";
import Breadcrumb from "./Breadcrumb";
import { useLayoutContext } from "./context";

export interface LayoutContentHeaderTopNavProps extends PropsWithChildren {
  className?: string;
  chatSupportButton?: ReactNode;
  applicationAndToolPanel?: ReactNode;
  profilePanel?: ReactNode;
  readonly?: boolean;
  appName?: string;
  compactMode?: boolean;
}

const ContentHeaderTopNav = ({
  children,
  className,
  chatSupportButton,
  applicationAndToolPanel,
  profilePanel,
  readonly,
  appName,
  compactMode,
}: LayoutContentHeaderTopNavProps) => {
  const { breadcrumbData, setOpenSidebar } = useLayoutContext();

  return (
    <div
      className={cn(
        compactMode
          ? "flex h-[57px] items-center justify-between gap-2 border-b border-neutral-95 bg-white px-6 py-2 max-sm-screen:pr-0 max-sm-screen:pl-4"
          : "flex h-[57px] items-center justify-between border-b border-neutral-95 bg-white px-6 py-2 max-sm-screen:px-4",
        className
      )}
    >
      {children || (
        <>
          <div
            className={cn(
              compactMode ? "hidden" : "hidden min-w-0 flex-1 items-center justify-between gap-2 mobile-screen:flex"
            )}
          >
            {breadcrumbData && !readonly && (
              <>
                <Breadcrumb
                  appName={breadcrumbData.appName}
                  appUrl={breadcrumbData.appUrl}
                  breadcrumbs={breadcrumbData.breadcrumbs}
                />
                {breadcrumbData.trailingContent}
              </>
            )}
          </div>
          <div className={compactMode ? "flex items-center gap-3" : "flex items-center gap-3 mobile-screen:hidden"}>
            {!compactMode && (
              <Button
                icon
                size="xs"
                color="secondary"
                variant="ghost"
                onClick={() => {
                  setOpenSidebar?.(true);
                }}
              >
                <MenuBurgerIcon className="size-5" />
              </Button>
            )}

            <span className="text-base font-bold text-neutral-10">{appName}</span>
          </div>
          <div className="flex items-center gap-2">
            {chatSupportButton || applicationAndToolPanel ? (
              <div className="flex items-center gap-0">
                {chatSupportButton}
                {applicationAndToolPanel}
              </div>
            ) : null}
            {profilePanel}
          </div>
        </>
      )}
    </div>
  );
};

export default ContentHeaderTopNav;
